// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 1, // Store Custom Code
    },
    // Store Custom Code
    errorCode: {
        invalidCustomerNumber: "INVALID_CUSTOMER_NUMBER",
        invalidBillToAddress: "INVALID_BILLTO_ADDRESS",
        productNotFound: "PRODUCT_NOT_FOUND",
        productPriceNotFound: "PRODUCT_PRICE_NOT_FOUND",
    },
});
